/*
 * Developed by CQ Inversiones SAS. Copyright ©. 2019 - 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS. Copyright ©. 2019 - 2024. Todos los derechos reservados.
 */

/*
* Project:      frontend
* Developed by: Jhoana Marcela Rodriguez Fernandez
* Date:         4/3/2024 - 17:03
* Module name:  frontend
* File name:    panel-card.const.ts
* IDE:          WebStorm
*/

import {PanelOptionInterface} from '../../interface';
import {customersValidations, systemValidations} from '@core/constants/users-module-permissions.const';

/**
 * @description
 * Menu option in the customer carousel
 */
export const PANEL_CARD_CUSTOMER: PanelOptionInterface[] = [
  {
    data: {
      level: customersValidations.contractsList.userRole,
      class: 'card_contract',
      description: 'app.setting.panel.admin.customer.option.contract.description',
    },
    url: 'app.setting.panel.admin.customer.option.contract.description',
    title: 'app.setting.panel.admin.customer.option.contract.title',
    icon: 'file-contract',
    link: 'contracts',
  },
  {
    data: {
      level: customersValidations.usersList.userRole,
      class: 'card_user',
      description: 'app.setting.panel.admin.customer.option.user.description',
    },
    url: 'app.setting.panel.admin.customer.option.user.description',
    title: 'app.setting.panel.admin.customer.option.user.title',
    icon: 'user',
    link: 'users',
  },
  {
    data: {
      level: customersValidations.groupsList.userRole,
      class: 'card_groups',
      description: 'app.setting.panel.admin.customer.option.group.description',
    },
    url: 'app.setting.panel.admin.customer.option.group.description',
    title: 'app.setting.panel.admin.customer.option.group.title',
    icon: 'users-gear',
    link: 'groups',
  },
  {
    data: {
      level: customersValidations.contactsList.userRole,
      class: 'card_contact',
      description: 'app.setting.panel.admin.customer.option.contacts.description',
    },
    title: 'app.setting.panel.admin.customer.option.contacts.title',
    icon: 'messages',
    link: 'contacts',
  },
  {
    data: {
      level: customersValidations.locationsList.userRole,
      class: 'card_location',
      description: 'app.setting.panel.admin.device.option.location.description',
    },
    title: 'app.setting.panel.admin.device.option.location.title',
    icon: 'location-dot',
    link: 'locations',
  },
];

/**
 * @description
 * Menu option in the device carousel
 */
export const PANEL_CARD_DEVICES: PanelOptionInterface[] = [
  {
    data: {
      level: customersValidations.customization.userRole,
      class: 'card_device_customization',
      description: 'app.setting.panel.admin.device.option.deviceCustomization.description',
    },
    title: 'app.setting.panel.admin.device.option.deviceCustomization.title',
    icon: 'pen-to-square',
    link: 'device-customization',
  },
  {
    data: {
      level: customersValidations.triggersList.userRole,
      class: 'card_triggers',
      description: 'app.setting.panel.admin.device.option.triggers.description',
    },
    title: 'app.setting.panel.admin.device.option.triggers.title',
    icon: 'bell-on',
    link: 'triggers',
  },
];

/**
 * @description
 * Menu option in the system carousel
 */
export const PANEL_CARD_SYSTEM: PanelOptionInterface[] = [
  {
    data: {
      level: systemValidations.defaultParameters.userRole,
      class: 'card_parameters',
      description: 'app.setting.panel.admin.system.option.parameters.description',
    },
    title: 'app.setting.panel.admin.system.option.parameters.title',
    icon: 'list-tree',
    link: 'parameters',
  },
  {
    data: {
      level: systemValidations.defaultCommands.userRole,
      class: 'card_commands',
      description: 'app.setting.panel.admin.system.option.commands.description',
    },
    title: 'app.setting.panel.admin.system.option.commands.title',
    icon: 'square-terminal',
    link: 'commands',
  },
  {
    data: {
      level: systemValidations.icons.userRole,
      class: 'card_icons',
      description: 'app.setting.panel.admin.system.option.icons.description',
    },
    title: 'app.setting.panel.admin.system.option.icons.title',
    icon: 'symbols',
    link: 'icons',
  },
  {
    data: {
      level: systemValidations.sensors.userRole,
      class: 'card_sensor',
      description: 'app.setting.panel.admin.system.option.sensor.description',
    },
    title: 'app.setting.panel.admin.system.option.sensor.title',
    icon: 'sensor-on',
    link: 'sensors',
  },
  {
    data: {
      level: systemValidations.deviceModel.userRole,
      class: 'card_model',
      description: 'app.setting.panel.admin.device.option.models.description',
    },
    title: 'app.setting.panel.admin.device.option.models.title',
    icon: 'laptop-file',
    link: 'device-model',
  },
  {
    data: {
      level: systemValidations.devices.userRole,
      class: 'card_device',
      description: 'app.setting.panel.admin.device.option.devices.description',
    },
    title: 'app.setting.panel.admin.device.option.devices.title',
    icon: 'computer-classic',
    link: 'devices',
  },
];

